import React, { useState, useContext, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
// Import react scroll
import { Link as LinkScroll } from "react-scroll"
// import ButtonOutline from "../misc/ButtonOutline."
import { ChevronRightIcon } from "@heroicons/react/outline"
import { AuthContext } from "context/Auth"

const Header = () => {
    let { pathname } = useLocation()
    console.log(pathname)
    const [activeLink, setActiveLink] = useState(null)
    const [scrollActive, setScrollActive] = useState(false)
    const { currentUser, logoutUser } = useContext(AuthContext)
    const [isMenuOpen, toggleMenu] = useState(false)

    useEffect(() => {
        if (pathname === "/") {
            window.addEventListener("scroll", () => {
                setScrollActive(window.scrollY > 20)
            })
        } else {
            setScrollActive(true)
        }
    }, [pathname])
    return (
        <>
            <header
                className={
                    "fixed top-0 w-full  z-30 text-white transition-all " +
                    (scrollActive ? " bg-white text-gray-900 shadow-md pt-0" : " pt-4")
                }
            >
                <nav className="border-gray-200 py-2 px-2 md:px-4 lg:px-5">
                    <div className="container mx-auto flex flex-wrap items-center justify-between">
                        <Link to="/" className="flex">
                            <img
                                alt="logo"
                                className="h-10 w-auto"
                                src="/assets/img/lsd_logo.gif"
                            />
                            <span className="ml-3 self-center text-lg whitespace-nowrap">
                                Lands and Surveys Department
                            </span>
                        </Link>
                        <button
                            type="button"
                            className={
                                "md:hidden ml-3 text-gray-100 hover:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300 rounded-lg inline-flex items-center justify-center" +
                                (scrollActive && " text-gray-600 hover:text-gray-900 ")
                            }
                            aria-controls="mobile-menu-2"
                            aria-expanded="false"
                            onClick={() => toggleMenu(!isMenuOpen)}
                        >
                            <span className="sr-only">Open main menu</span>
                            <svg
                                className="w-6 h-6"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                            <svg
                                className="hidden w-6 h-6"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </button>
                        <div
                            className={`${
                                isMenuOpen
                                    ? "absolute bg-white text-gray-800 rounded-lg top-16 right-2 p-2 shadow"
                                    : "hidden md:block"
                            } w-2/3 md:w-auto`}
                        >
                            <ul className="flex-col md:flex-row flex items-center md:space-x-8 mt-4 md:mt-0 md:text-md md:font-medium">
                                <Link
                                    to="/"
                                    className={
                                        "px-4 py-2 mx-2 hover:bg-gray-300 rounded cursor-pointer animation-hover inline-block relative" +
                                        (!scrollActive && " hover:text-gray-900 ")
                                    }
                                >
                                    Home
                                </Link>
                                <Link
                                    to="/about"
                                    className={
                                        "px-4 py-2 mx-2 hover:bg-gray-300 rounded cursor-pointer animation-hover inline-block relative" +
                                        (!scrollActive && " hover:text-gray-900 ")
                                    }
                                >
                                    About
                                </Link>
                                <li className="group relative">
                                    <Link
                                        to="/services"
                                        className={`hover:bg-gray-300 py-2 px-4 rounded inline-flex items-center ${!scrollActive &&
                                            " hover:text-gray-900"}`}
                                    >
                                        <span className="mr-1">Services</span>
                                        <svg
                                            className="fill-current h-4 w-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                        >
                                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                        </svg>
                                    </Link>
                                    <ul className="absolute hidden bg-white rounded shadow-lg text-gray-700 pt-1 group-hover:block">
                                        {[
                                            "surveying",
                                            "recording",
                                            "map products",
                                            "training",
                                            "land registration",
                                        ].map((service, index) => (
                                            <li className="w-40" key={index}>
                                                <a
                                                    className="bg-white hover:bg-gray-200 capitalize py-2 px-4 block whitespace-no-wrap"
                                                    href={`/services/${service}`}
                                                >
                                                    {service}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </li>

                                {/* <Link
                                    to="/map"
                                    className={
                                        "px-4 py-2 mx-2 hover:bg-gray-300 rounded cursor-pointer animation-hover inline-block relative" +
                                        (!scrollActive && " hover:text-gray-900 ")
                                    }
                                >
                                    Map{" "}
                                    <span className="hidden md:inline-block">
                                        of Barbados
                                    </span>
                                </Link> */}

                                <Link
                                    to="/contact"
                                    className={
                                        "px-4 py-2 mx-2 hover:bg-gray-300 rounded cursor-pointer animation-hover inline-block relative" +
                                        (!scrollActive && " hover:text-gray-900 ")
                                    }
                                >
                                    Contact
                                </Link>

                                <Link to="/login">
                                    <div
                                        className={
                                            "border border-white rounded px-4 py-2 text-black-600 capitalize tracking-wide hover:text-orange-500 transition-all" +
                                            (scrollActive &&
                                                " border-gray-800 border-2 hover:text-gray-900 ")
                                        }
                                    >
                                        {currentUser ? "View App" : "Sign In"}
                                    </div>
                                </Link>
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>
        </>
    )
}

export default Header
